import { ClassroomStudent } from "@/types/models/Classroom.interface";

export const studentNameComparator = (
  a: ClassroomStudent,
  b: ClassroomStudent,
): number => {
  const nameA = `${a?.user?.first_name || ""}${a?.user?.last_name || ""}`;
  const nameB = `${b?.user?.first_name || ""}${b?.user?.last_name || ""}`;
  return nameA.localeCompare(nameB);
};
